import {
  FormGroup,
  Input,
  InputV2,
  SelectInputV2Props,
} from '@southfields-digital/mpxlive-components';

import styles from './RundownTemplateForm.module.scss';

interface IRundownTemplateFormProps {
  state: Partial<RundownTemplate>;
  graphicsPackages: SelectInputV2Props['options'];
  stateUpdated: (state: Partial<RundownTemplate>) => void;
}

export default function RundownTemplateForm({
  state,
  graphicsPackages,
  stateUpdated,
}: IRundownTemplateFormProps) {
  const updateState = (newState: Partial<RundownTemplate>) => {
    if (!state) return;

    stateUpdated({ ...state, ...newState });
  };

  return (
    <div className={styles.RundownForm}>
      <Input
        label="Template name"
        value={state.name}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          updateState({ name: e.currentTarget.value })
        }
      />

      <FormGroup label="Select graphics package" htmlFor="graphicsPackage">
        <InputV2
          type="select"
          inputSize="lg"
          id="graphicsPackage"
          value={state.graphicPackageId}
          options={graphicsPackages}
          placeholder="Pick a graphics package"
          onChange={(e) => {
            updateState({
              graphicPackageId: e.currentTarget.value,
              canvases: [],
            });
          }}
          // TODO: REMOVE THIS STYLING OVERRIDE WHEN ALL INPUTS USE INPUTV2
          wrapperClassName="!min-h-[42px] !rounded-[4px] !bg-elevated-0 !border-gray-800"
        />
      </FormGroup>
    </div>
  );
}
